// Single source of truth for which modules/pages a location may open. Used by the Sidebar
// (to build the menu) and by RouteAccessGuard (to block the same pages when the URL is
// typed in directly), so the two can't drift apart.

export const WINE_SOL_LOCATION_ID = "7ab06ab8-214b-48b3-b569-02bd7b6c21a7";
export const SALES_LIMITED_LOCATION_ID = "0aa382e3-061c-4afc-a632-5bc2139075a0";
// Temporary: force-enable Kards for this location regardless of permissions.giftCard
export const GIFT_KARD_ENABLED_LOCATION_ID = "3776639b-5e59-4159-a680-52377f0aa608";
export const SEGMENTS_DISABLED_LOCATION_ID = "6e7083b4-cc2f-4601-918e-a844a02e8cc2";

export const CREATE_PO_PATH = "/product-catalogs/create-po";

// `module` is the first URL segment; `path` is the module's landing page.
export const getModuleAccessRules = (permissions, locationUid) => [
  { module: "loyalty", path: "/loyalty/dashboard", allowed: Boolean(permissions?.loyalty) },
  { module: "inventory", path: "/inventory/items", allowed: Boolean(permissions?.inventory) },
  { module: "promotions", path: "/promotions/dashboard", allowed: Boolean(permissions?.coupons) },
  { module: "gift-kard", path: "/gift-kard/dashboard", allowed: locationUid === GIFT_KARD_ENABLED_LOCATION_ID || Boolean(permissions?.giftCard) },
  { module: "purchase-management", path: "/purchase-management/vendors", allowed: Boolean(permissions?.purchase) },
  { module: "whole-sales", path: "/whole-sales/retailers", allowed: Boolean(permissions?.wholesale) },
  { module: "pricing", path: "/pricing", allowed: Boolean(permissions?.pricing) },
  { module: "communication", path: "/communication/dashboard", allowed: Boolean(permissions?.communication) },
  { module: "scan-data", path: "/scan-data/dashboard", allowed: Boolean(permissions?.scanData) },
  { module: "sales", path: "/sales/dashboard", allowed: Boolean(permissions?.sales) },
  { module: "lottery", path: "/lottery/dashboard", allowed: Boolean(permissions?.lottery) },
  { module: "analytics", path: "/analytics", allowed: Boolean(permissions?.analyticsEngine) },
  { module: "account", path: "/account", allowed: Boolean(permissions?.settings) },
];

// Pages inside an enabled module that are still hidden from the menu.
const getBlockedSubPaths = (permissions, locationUid) => {
  const blocked = [];
  if (locationUid === SALES_LIMITED_LOCATION_ID) blocked.push("/sales/online-store", "/sales/settings");
  if (locationUid === SEGMENTS_DISABLED_LOCATION_ID) blocked.push("/loyalty/segments", "/communication/notifications");
  if (!permissions?.mobileApp) blocked.push("/communication/notifications");
  return blocked;
};

const isUnder = (pathname, basePath) => pathname === basePath || pathname.startsWith(`${basePath}/`);

// Returns { allowed: true } or { allowed: false, fallbackPath } where fallbackPath is the
// page to send the user to instead (null when the location has no enabled module at all).
export const getRouteAccess = ({ pathname, permissions, locationUid }) => {
  // The Wine Sol location has its own fixed menu and isn't driven by permissions.
  if (locationUid === WINE_SOL_LOCATION_ID) return { allowed: true };

  const rules = getModuleAccessRules(permissions, locationUid);
  const firstAllowedPath = rules.find((rule) => rule.allowed)?.path || null;
  const currentModule = pathname.split("/")[1];

  if (currentModule === "wine-sol") return { allowed: false, fallbackPath: firstAllowedPath };

  const currentRule = rules.find((rule) => rule.module === currentModule);
  if (currentRule && !currentRule.allowed) return { allowed: false, fallbackPath: firstAllowedPath };

  const isBlockedSubPath = getBlockedSubPaths(permissions, locationUid).some((blocked) => isUnder(pathname, blocked));
  if (isBlockedSubPath) return { allowed: false, fallbackPath: currentRule?.path || firstAllowedPath };

  return { allowed: true };
};
